import HomeMobileMenu from "./modules/header_mobile_menu";
import HomeVideo from "./widgets/home-video";
import NewsletterSubscription from "./widgets/newsletter-subscription";
import DomEvents from './modules/dom-events';
import ContactForm from './widgets/contact-form';
import NewsletterUnsubscribe from "./widgets/newsletter-unsubscribe";

let domEvents = new DomEvents();
domEvents.init();

document.querySelectorAll('[data-id="widget-newsletter-subscription"]').forEach((el) => {
    if (el.dataset.format === 'format-1') {
        let byId = document.querySelector('[data-id="widget-footer__newsletter-subscription"]');
        if (byId) {
            byId.append(el);
            el.style.display = '';
            new NewsletterSubscription(el);
        }
    } else {
        new NewsletterSubscription(el);
    }
});

document.querySelectorAll('[data-id="widget-home-video"]').forEach((el) => {
    new HomeVideo(el);
});

document.querySelectorAll('[data-id="widget-header"]').forEach((el) => {
    new HomeMobileMenu(el);
});

document.querySelectorAll('[data-id="widget-contact-form"]').forEach((el) => {
    new ContactForm(el);
});

document.querySelectorAll('[data-id="widget-newsletter-unsubscribe"]').forEach((el) => {
    new NewsletterUnsubscribe(el);
});